import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["invited.factoringLoading"],
  loading => loading
);
